type BrowserStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

// Non-secret UI/session metadata only. Cookies remain the authentication authority.
export function createResilientStorage(resolve: () => BrowserStorage): BrowserStorage {
  const memory = new Map<string, string>();
  let unavailable = false;
  return {
    getItem(key) {
      if (!unavailable) {
        try {
          const value = resolve().getItem(key);
          if (value === null) memory.delete(key);
          else memory.set(key, value);
          return value;
        } catch { unavailable = true; }
      }
      return memory.get(key) ?? null;
    },
    setItem(key, value) {
      memory.set(key, value);
      if (!unavailable) {
        try { resolve().setItem(key, value); }
        catch { unavailable = true; }
      }
    },
    removeItem(key) {
      memory.delete(key);
      if (!unavailable) {
        try { resolve().removeItem(key); }
        catch { unavailable = true; }
      }
    },
  };
}

export const browserSessionStorage = createResilientStorage(() => window.sessionStorage);
export const browserLocalStorage = createResilientStorage(() => window.localStorage);
